import { render, staticRenderFns } from "./TargetScoreModal.vue?vue&type=template&id=0d44a209&scoped=true"
import script from "./TargetScoreModal.vue?vue&type=script&lang=js"
export * from "./TargetScoreModal.vue?vue&type=script&lang=js"
import style0 from "./TargetScoreModal.vue?vue&type=style&index=0&id=0d44a209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d44a209",
  null
  
)

export default component.exports